<template>
    <div class="page">
        <template v-for="widget of widgets">
            <component :is="type(widget)" :configuration="widget" />
        </template>
    </div>
</template>

<script>
    import Vue from 'vue';

    const types = {
        text: 'idom',
        aside: 'sidebar',
        image: 'media',
        embed: 'media'
    };

    export default {
        name: 'Page',
        props: {
            configuration: Object
        },
        computed: {
            widgets(){
                if(!this.configuration.contents){
                    return [];
                }

                return this.configuration.contents.slice()
                .filter(widget => widget.type === 'widget')
                .sort((a, b) => {
                    return this.configuration.body.indexOf(a.data.guid) - this.configuration.body.indexOf(b.data.guid);
                });
            }
        },
        methods: {
            type(widget){
                if(types.hasOwnProperty(widget.contentType)){
                    return types[widget.contentType];
                }

                return widget.contentType;
            }
        }
    }
</script>

<style lang="less">
    @import "~@/assets/less/variables";


</style>
